var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.18182 27.7391H7.27273V15.6502L0 10.3169V25.6058C0 26.7845 0.976364 27.7391 2.18182 27.7391Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7275 27.7391H29.8184C31.0239 27.7391 32.0003 26.7845 32.0003 25.6058V10.3169L24.7275 15.6502V27.7391Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7275 6.40568V15.6501L32.0003 10.3168V7.47235C32.0003 4.83591 28.9221 3.33013 26.7639 4.91235L24.7275 6.40568Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27246 15.6502V6.40576L15.9997 12.8058L24.727 6.40576V15.6502L15.9997 22.0502L7.27246 15.6502Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 7.47235V10.3168L7.27273 15.6501V6.40568L5.23636 4.91235C3.07818 3.33013 0 4.83591 0 7.47235Z",
    fill: "#C5221F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGmail);
export default __webpack_public_path__ + "static/media/icon-gmail.ad3cfa0e264dfd7ad0d490ac21f57202.svg";
export { ForwardRef as ReactComponent };